import Nullstack from 'nullstack';
export default function IconDeviceMobileCharging({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-device-mobile-charging",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "6",
    y: "3",
    width: "12",
    height: "18",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M11 4h2"
  }), "   ", Nullstack.element("path", {
    d: "M12 9.5l-1 2.5h2l-1 2.5"
  }), " ");
}